import {lazy} from 'react';

export const ProfileSettingsAsync = lazy(() =>
    import('./ProfileSettings')
);
